class SearchFilter extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      filterDetails: this.querySelectorAll('details'),
      filterSummary: this.querySelectorAll('summary'),
      filterItems: this.querySelectorAll('.filter-select__item:not(.holder)'),
      filterSubmitButton: this.querySelector('.filter-value'),
    };

    if (!this.elements.filterSubmitButton.hasAttribute('data-previous-href')) {
      this.elements.filterSubmitButton.setAttribute('data-previous-href', this.elements.filterSubmitButton.getAttribute('href'));
    }
    this.previousHref = this.elements.filterSubmitButton.getAttribute('data-previous-href');

    this.elements.filterDetails.forEach(item => {
      item.addEventListener('click', this.closeDetails.bind(this, item));
      const summary = item.querySelector('summary');
      if (summary) {
        summary.setAttribute('tabindex', '0');
        summary.addEventListener('keydown', this.handleKeyDown.bind(this, item));
        item.addEventListener('focusout', this.handleFocusOut.bind(this, item));
      }
    });

    document.addEventListener('click', this.closeAllDetails.bind(this));

    this.elements.filterItems.forEach(item => {
      item.addEventListener('click', this.onClick.bind(this, item));
      item.setAttribute('tabindex', '0');
      item.addEventListener('keydown', this.handleItemKeyDown.bind(this, item));
    });
  }

  handleKeyDown(details, event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      details.open = !details.open;
    }
  }

  handleItemKeyDown(item, event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onClick(item);
    }
  }

  closeDetails(clickedItem) {
    this.elements.filterDetails.forEach(item => {
      if (item !== clickedItem) {
        item.removeAttribute('open');
      }
    });
  }

  closeAllDetails(event) {
    if (!Array.from(this.elements.filterDetails).some(item => item.contains(event.target))) {
      this.elements.filterDetails.forEach(item => {
        item.removeAttribute('open');
      });
    }
  }

  handleFocusOut(details, event) {
    setTimeout(() => {
      if (!details.contains(document.activeElement)) {
        details.removeAttribute('open');
      }
    }, 0);
  }

  onClick(clickedItem) {
    const parentDetails = clickedItem.closest('details');
    const summaryElement = parentDetails.querySelector('summary span');

    if (summaryElement) {
      summaryElement.textContent = clickedItem.textContent;
    }

    clickedItem.classList.toggle('active');
    const otherItems = parentDetails.querySelectorAll('.filter-select__item:not(.holder)');
    otherItems.forEach(item => {
      if (item !== clickedItem) {
        item.classList.remove('active');
      }
    });

    parentDetails.removeAttribute('open');

    this.updateFilters();
  }

  updateFilters() {
    const activeItems = this.querySelectorAll('.filter-select__item.active:not(.holder)');
    // Prima prendi i valori, poi sostituisci virgole con %2C e spazi con +
    const dataFilterValues = Array.from(activeItems)
      .map(item => {
        let filter = item.getAttribute('data-filter');
        // Encodare le virgole nei valori (dopo il segno =)
        return filter.replace(/=(.*)/, (match, value) => {
          return '=' + value
            .replace(/,/g, '%2C')  // Virgole diventano %2C
            .replace(/%20/g, '+')   // %20 diventa +
            .replace(/\s/g, '+');   // Spazi diventano +
        });
      })
      .join('&');
    
    const currentValue = this.previousHref || '';

    fetch(`${currentValue}?${dataFilterValues}`)
      .then(response => response.text())
      .then(responseText => {
        const html = responseText;
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
        const disabledElements = parsedHTML.querySelectorAll('facet-filters-form .list-menu__item input[disabled]');

        this.elements.filterItems.forEach(filterItem => {
          const filterItemValue = filterItem.getAttribute('data-filter');
          filterItem.classList.remove('disabled');
          filterItem.removeAttribute('disabled');

          disabledElements.forEach(disabledElement => {
            const disabledValues = disabledElement.getAttribute('data-filter');

            if (filterItemValue === disabledValues) {
              filterItem.classList.add('disabled');
              filterItem.setAttribute('disabled', '');
              filterItem.setAttribute('tabindex', '-1');
            }
          });
        });
      });

    this.elements.filterSubmitButton.setAttribute('href', `${currentValue}?${dataFilterValues}`);
    this.elements.filterSubmitButton.removeAttribute('aria-disabled');
  }
}

customElements.define('search-filter', SearchFilter);